export default __webpack_public_path__ + "static/media/PlayStation.d02c022b.svg";